<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_26_942)">
<rect y="24" width="24" height="24" rx="12" transform="rotate(-90 0 24)" fill="#e8cbf2"/>
<circle cx="12" cy="12" r="4" transform="rotate(-90 12 12)" fill="white"/>
</g>
<defs>
<clipPath id="clip0_26_942">
<rect y="24" width="24" height="24" rx="12" transform="rotate(-90 0 24)" fill="white"/>
</clipPath>
</defs>
</svg>
